export default __webpack_public_path__ + "static/media/272.1274a3d6.png";